import React, { Fragment, useRef, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { Label, FormGroup, Col } from "reactstrap";
import { withTranslation } from "react-i18next";
import Icon from "../icon";
import "./custom-modal-select.styles.scss";
import "./multi-creatable-select-without-menu.scss";

const MultiCreatableSelectWithoutMenu = (props) => {
    const {
        t,
        colSm,
        labelSm,
        labelName,
        errors,
        className,
        name,
        placeholder,
        handleCreateOption,
        handleDeleteOption,
        isMulti,
        ...childProps
    } = props;

    const selectRef = useRef<any>(null);
    const [inputValue, setInputValue] = useState("");

    const CustomOptions = ({ innerRef, innerProps, isDisabled, children, data, isSelected }) =>
        !isDisabled ? (
            <div ref={innerRef} {...innerProps} className={`deleteable-option ${isSelected ? "selected-opt" : ""}`}>
                {children}
                <Icon
                    name="x"
                    className="btn btn-custom-round mr-20 mt-5"
                    style={{ float: "right" }}
                    onClick={() => handleDeleteOption(data)}
                />
            </div>
        ) : null;

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key !== "Enter") return;

        e.preventDefault();
        e.stopPropagation();

        const inputVal = inputValue?.trim();
        if (!inputVal) return;

        const options = childProps.options ?? [];
        const existing = options.find(
        (opt) =>
            (opt?.label && String(opt.label).toLowerCase() === inputVal.toLowerCase()) ||
            (opt?.value && String(opt.value).toLowerCase() === inputVal.toLowerCase())
        );

        const currentValue = childProps.value;
        const currentArr = Array.isArray(currentValue)
            ? currentValue
            : currentValue != null
            ? [currentValue]
            : [];

        if (existing) {
            const alreadySelected = currentArr.some((v) => String(v?.value) === String(existing.value));
        if (!alreadySelected) {
            childProps.onChange?.([...currentArr, existing]);
        }
        } else {
            handleCreateOption && handleCreateOption(inputVal, name);
        }

        setInputValue("");
    };


    return (
        <Fragment>
            <FormGroup row>
                <Label sm={labelSm || 3}>{t(labelName)}:</Label>
                <Col sm={colSm}>
                    <CreatableSelect
                        ref={selectRef}
                        className={`creatable-select ${className || ""} ${errors ? "custom-gt-select is-invalid" : ""}`}
                        isClearable
                        styles={customStyles}
                        name={name}
                        tabSelectsValue
                        placeholder={placeholder ? `${t(placeholder)}...` : `${t(labelName)}...`}
                        onCreateOption={(value) => handleCreateOption && handleCreateOption(value, name)}
                        components={handleDeleteOption && { Option: CustomOptions }}
                        formatCreateLabel={(v) => <span style={{ color: "#2fc787" }}>{`${t("Add")} "${v}"`}</span>}
                        isMulti={isMulti ?? true}
                        inputValue={inputValue}
                        onInputChange={(value, actionMeta) => {
                            if (actionMeta.action === "input-change") setInputValue(value);
                        }}
                        {...childProps}
                        filterOption={(option, inputVal) => {
                            if (!inputVal) return true;
                            const labelStr = (option?.label ?? option).toString().toLowerCase();
                            return labelStr.includes(inputVal.toLowerCase());
                        }}
                        onKeyDown={handleKeyDown}
                    />
                    {errors && <Label className="invalid-feedback">{t(errors)}</Label>}
                </Col>
            </FormGroup>
        </Fragment>
    );
};

export default withTranslation()(MultiCreatableSelectWithoutMenu);

const customStyles = {
    indicatorsContainer: () => ({
        display: "none",
    }),
    valueContainer: (css, state) => {
        return state.selectProps.notLabeled
            ? {
                  ...css,
                  maxHeight: "27px",
                  paddingLeft: "17px",
              }
            : {
                  ...css,
                  paddingLeft: "17px",
              };
    },
    singleValue: (css) => {
        return { ...css, color: "unset" };
    },
    control: (css, state) => {
        let newCSS = {
        ...css,
        borderColor: state.isFocused ? "#2fc78790" : "#eaecf0",
        "&:hover": {
            borderColor: state.isFocused ? "#2fc78790" : "#eaecf0",
        },
        boxShadow: state.isFocused ? "0 0 0 0.2rem #2fc78740" : "",
        };
        if (state.selectProps.notLabeled) {
        newCSS = { ...newCSS, minHeight: "27px", height: "27px" };
        }
        return newCSS;
    },
    menu: () => ({
        display: "none",
    }),
};
